import React, { useState } from 'react';
import '../css/contacto.css';
import { useNavigate } from 'react-router-dom';

const Contacto = () => {
    const navigate = useNavigate()
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });
  const [status, setStatus] = useState({ enviando: false, mensaje: '', tipo: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ enviando: true, mensaje: 'Enviando mensaje...', tipo: 'info' });

    try {
      const response = await fetch("https://api-nnlftslgtq-uc.a.run.app/contacto/enviar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ enviando: false, mensaje: '¡Mensaje enviado con éxito!', tipo: 'ok' });
        setFormData({ nombre: '', email: '', asunto: '', mensaje: '' });
        setTimeout(() => {
            navigate('/')
        }, 2000);
      } else {
        throw new Error();
      }
    } catch (error) {
      setStatus({ enviando: false, mensaje: 'Error al enviar. Inténtalo de nuevo.', tipo: 'error' });
    }
  };

  return (
    <div className="contacto-page animate-fade-in">
      <div className="contacto-header">
        <h1>Contacta con El Reto de Carmen</h1>
        <p>¿Dudas, sugerencias o simplemente quieres saludar? Escríbenos.</p>
      </div>

      <div className="form-container-card">
        <form onSubmit={handleSubmit} className="contacto-form">
          <div className="input-group">
            <input
              type="text"
              name="nombre"
              className="custom-input"
              value={formData.nombre}
              onChange={handleChange}
              required
              placeholder=" " 
            />
            <label>Nombre completo</label>
          </div>

          <div className="input-group">
            <input
              type="email"
              name="email"
              className="custom-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Correo electrónico</label>
          </div>

          <div className="input-group">
            <input
              type="text"
              name="asunto"
              className="custom-input"
              value={formData.asunto}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Asunto</label>
          </div>

          <div className="input-group">
            <textarea
              name="mensaje"
              className="custom-textarea"
              value={formData.mensaje}
              onChange={handleChange}
              required
              placeholder=" "
            ></textarea>
            <label>Tu mensaje</label>
          </div>

          <button 
            type="submit" 
            className="hash-button btn-full" 
            disabled={status.enviando}
          >
            {status.enviando ? 'PROCESANDO...' : 'ENVIAR MENSAJE'}
          </button>

          {status.mensaje && (
            <p className={`${status.tipo === 'error' ? 'error-message' : 'ok-message'}`}>
              {status.mensaje}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contacto;